/* Choix de l'onglet Doctipro (plusieurs ouverts) et confirmation du patient avant un collage. */
import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

let ouvrir = null;
export const demanderOngletDoctipro = (demande) => new Promise((resolve) => {
  if (!ouvrir) { resolve(demande.onglets[0]?.tabId ?? null); return; }
  ouvrir({ ...demande, resolve });
});

export const nomPatientOnglet = (o) => {
  const p = o?.patient;
  const nom = [p?.nom?.toUpperCase(), p?.prenom].filter(Boolean).join(' ');
  return nom ? `${nom}${p.naissance ? ` · né(e) le ${p.naissance}` : ''}` : '';
};

const Onglet = ({ o, i, onClick }) => {
  const nom = nomPatientOnglet(o);
  return (
    <button onClick={onClick} data-testid={`onglet-doctipro-choix-${i}`}
      className="w-full text-left rounded-xl border border-gray-200 hover:border-[#1173D4] hover:bg-[#1173D4]/5 px-4 py-3 transition-colors">
      <div className="flex items-center gap-2">
        <p className={`flex-1 text-sm font-bold ${nom ? 'text-[#0B1F3A]' : 'text-gray-400 italic'}`}>{nom || 'Aucune fiche patient reconnue'}</p>
        {i === 0 && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-sky-100 text-sky-700 flex items-center gap-1"><Clock className="h-3 w-3" /> Dernière consultée</span>}
      </div>
      <p className="text-xs text-gray-500 truncate mt-0.5">{o.titre || 'Onglet Doctipro'}</p>
    </button>
  );
};

export const ChoixOngletDoctipro = () => {
  const [d, setD] = useState(null);
  useEffect(() => { ouvrir = setD; return () => { ouvrir = null; }; }, []);
  const fin = (tabId) => { d?.resolve(tabId); setD(null); };
  if (!d) return null;
  const coller = d.mode === 'coller';
  const seul = d.onglets.length === 1;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) fin(null); }}>
      <DialogContent className="max-w-md z-[200]" data-testid="choix-onglet-doctipro">
        <DialogHeader>
          <DialogTitle>{coller ? (seul ? 'Confirmer le patient Doctipro' : `Coller « ${d.titre} » chez quel patient ?`) : 'Quel onglet Doctipro utiliser ?'}</DialogTitle>
          <DialogDescription>
            {coller && seul ? `« ${d.titre} » va être collé dans l'onglet Doctipro de :` : `${d.onglets.length} pages Doctipro sont ouvertes. Choisissez la bonne fiche patient.`}
          </DialogDescription>
        </DialogHeader>
        {coller && seul ? (
          <p className="text-base font-extrabold text-[#0B1F3A] rounded-xl bg-sky-50 border border-sky-200 px-4 py-3" data-testid="choix-onglet-patient">
            {nomPatientOnglet(d.onglets[0]) || 'Aucune fiche patient reconnue sur cette page'}
          </p>
        ) : (
          <div className="space-y-2 max-h-[50vh] overflow-y-auto">
            {d.onglets.map((o, i) => <Onglet key={o.tabId} o={o} i={i} onClick={() => fin(o.tabId)} />)}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => fin(null)} data-testid="choix-onglet-annuler">Annuler</Button>
          {coller && seul && <Button onClick={() => fin(d.onglets[0].tabId)} data-testid="choix-onglet-confirmer">Coller chez ce patient</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
